import { ReactNode } from 'react';
import DesktopOnlyWrapper from 'src/components/common/DesktopOnlyWrapper';

const NoAuthProvider = ({ children }: { children: ReactNode }) => {
  return <DesktopOnlyWrapper>{children}</DesktopOnlyWrapper>;
};

export default NoAuthProvider;
